import { Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function validatePersonalTimeRecords(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>, date: string) => {
    const d = new Date(date);

    return httpClient.sendHttpRequest<void>({
      endpoint: `/resources/${resource.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        integratedAt: new Date(
          Date.UTC(
            d.getUTCFullYear(),
            d.getUTCMonth(),
            d.getUTCDate(),
            23,
            59,
            59,
          ),
        ).toISOString(),
      },
    });
  };
}

export { validatePersonalTimeRecords };
